import { GENERAL } from '@app/constants/endpoints';

const redirectToGeneral = () => {
  const redirect = encodeURIComponent(window.location.href);

  const loginUrl = `${GENERAL}/?redirect=${redirect}`;

  return window.location.replace(loginUrl);
};

export const redirectToGeneralAfterLogOut = () => {
  return window.location.replace(`${GENERAL}/#/select`);
};

export default redirectToGeneral;
